document.addEventListener('DOMContentLoaded', () => {
  /** @type {NodeListOf<HTMLInputElement>} */
  const checkboxes = document.querySelectorAll('.product-extra__checkbox');

  if (checkboxes.length === 0) return;

  checkboxes.forEach((checkbox) => {
    const wrapper = checkbox.closest('.product-extra');

    const syncSelectionState = () => {
      if (!(wrapper instanceof HTMLElement)) return;
      wrapper.dataset.selected = checkbox.checked ? 'true' : 'false';
    };

    syncSelectionState();
    checkbox.addEventListener('change', syncSelectionState);
  });
});